export enum MutationTypes {
  SET_INSPECTIONS = "inspection-events/set-inspections",
  SET_INSPECTIONS_FOR_CSV = "inspection-events/set-inspections-for-csv",
  SET_INSPECTIONS_META = "inspection-events/set-inspections-meta",
  SET_INSPECTION = "inspection-events/set-inspection",
  SET_INSPECTION_SETTINGS = "inspection-events/set-inspection-settings",
}
